import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import {rootStore, StateContext} from "./stores/rootStore";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

const StateProvider: React.FC = (props) => {
  return (
    <StateContext.Provider value={rootStore}>
      {props.children}
    </StateContext.Provider>
  );
};

ReactDOM.render(
  <BrowserRouter basename={baseUrl ?? ""}>
    <StateProvider>
      <App />
    </StateProvider>
  </BrowserRouter>,
  rootElement
);

// Temporarily disable service worker and client side precache
// as the SW will intercept all server side GET calls atm, that
// stops us from navigating to /account/signin to sign in
// We will need to blacklist the /account/* using workbox config:
// https://dev.to/jeffposnick/service-workers-in-create-react-app-v4-3mm0
// registerServiceWorker();
